(function ($) {
  toutWithCtaV1 = {
    formatter: $('.tout-with-cta-v1')
  };

  Drupal.behaviors.toutWithCtaV1 = {
    get: function (key) {
      return toutWithCtaV1[key];
    },

    set: function (key, val) {
      toutWithCtaV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var borderColor = thisFormatter.find('.border-color').attr('data-border-color');

        thisFormatter.css({ 'border-color': borderColor });
        var bgColor = thisFormatter.find('.bg-color').attr('data-bg-color');

        thisFormatter.find('.row').css({ 'background-color': bgColor });
        var headingColor = thisFormatter.find('.heading-color').attr('data-heading-color');

        thisFormatter.find('.section-title').css({ 'color': headingColor });
        var subHeadingColor = thisFormatter.find('.subheading-color').attr('data-subheading-color');

        thisFormatter.find('.section-subtitle').css({ 'color': subHeadingColor });
      });
    }
  };
})(jQuery);
